import { IntegratedRecordsList } from 'components/IntegratedRecordsList';
import React from 'react';
import { connect } from 'react-redux';
import { ApplicationState, DhamRecord } from 'types';
import { RecordsHandler } from './RecordsHandler';
import { ViewTile } from './viewTile';

let CSS = `
#selection-dropdown {
    display: none !important;
}

.dham-records-record .row {
    padding-top: 5px;
    padding-bottom: 5px;
}

.dham-records-record .row:last-of-type {
    border-bottom: none;
}

#record_count {
    margin-top: 12px;
}

.tile.dham-records-record.detail {
    padding-top: 15px;
}

.tile.dham-records-record .main-details {
    padding-right: 30px;
    padding-left: 30px;
}

.tile.dham-records-record .main-details .title {
	text-align: right;
	padding: 0;
	padding-bottom: 25px;
    font-weight: bold;
    font-size: 0.9em;
}

form.tile.dham-records-record .main-details .value {
	padding-right: 0;
}

.tile.dham-records-record input {
	width: 100%;
	background-color: white!important;
    border: none;
    border-bottom: 1px solid darkgray;
}

form.tile.dham-records-record textarea {
	width: 100%;
    min-height: 6em;
}

.tile.dham-records-record textarea {
    border: 1px solid darkgray;
    padding: 10px;
    overflow: auto;
    max-height: 12em;
}

.tile.dham-records-record input:focus {
    outline: none;    
}

.tile.dham-records-record .value select {
	width: 100%;
}

div.tile.dham-records-record .main-details .value {
    border-bottom: 1px solid lightgrey;
    min-height: 1.5em;
}

.title {
    text-align: right;
    font-weight: bold;
    font-size: 0.9em;
}
`;

const html = `
<style>
	${CSS}
</style>

<div id="page-records">
    <div class="records">
        <div class="filtered-records">
        </div>
    </div>
</div>
`;

interface Props {
	records: DhamRecord[];
}

class Component extends React.Component<Props> {
	render() {
		return (
			<React.Fragment>
				<IntegratedRecordsList
					records={this.props.records}
					RecordTile={ViewTile}
					html={html}
					RecordsHandler={RecordsHandler}
				/>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state: ApplicationState) {
	return {
		records: state.dataState.dham.filtered,
	};
}

export const Dham = connect(mapStateToProps)(Component);
